

import React, { memo } from 'react';
import cx from 'classnames';

import Image from '../components/Image';
import '../styles/_image-with-content.scss';






const ImageWithContent = (props) => {
  const { children, className, ...imageProps } = props;
  const hasChildren = React.Children.toArray(children).length > 0;

  return (
    <div className={cx('image-with-content', className)}>
      <Image {...imageProps} />

      {hasChildren && <div className="image-with-content__content">{children}</div>}
    </div>);

};

export default memo(ImageWithContent);